import { render, staticRenderFns } from "./FreezePeriodBanner.vue?vue&type=template&id=7fc897f0"
import script from "./FreezePeriodBanner.vue?vue&type=script&lang=ts"
export * from "./FreezePeriodBanner.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports